import { FormConfig, FormField } from '../api/types/form';
import { FormValues } from '../components/form/types';
import camelCase from 'lodash/camelCase';
import snakeCase from 'lodash/snakeCase';
import { TemplateFormType } from "./cms";

export function buildValueObj(config: FormConfig | null): FormValues {
    const newValues: FormValues = {};
    if (!config) {
        return newValues;
    }
    const buildFieldValue = (field: FormField) => {
        if (field.name) {
            const newKey = camelCase(field.name);
            if (typeof field.value !== 'undefined') {
                if (
                    field.type === 'choice' &&
                    field.value instanceof Object &&
                    field.value.id
                ) {
                    if (field.attr?.['data-upload']) {
                        newValues[newKey] = field.value;
                    } else {
                        newValues[newKey] = field.value.id;
                    }
                } else {
                    if (
                        field.value instanceof Array &&
                        field.type !== 'choice'
                    ) {
                        newValues[newKey] = findValues(field.value);
                    } else {
                        newValues[newKey] = field.value;
                    }
                }
            }
        }
    };

    for (const field of config.fields) {
        buildFieldValue(field);
    }
    for (const field of config.additional_fields ?? []) {
        buildFieldValue(field);
    }
    return newValues;
}

export function objectPropsToCamelCase(obj: FormValues): FormValues {
    const result: FormValues = {};
    for (const key of Object.keys(obj)) {
        result[camelCase(key)] = obj[key];
    }
    return result;
}

export function buildChildConfig(
    children: Array<FormField>,
    values: FormValues,
): Array<FormField> {
    const result: Array<FormField> = [];
    for (const field of children) {
        const temp = { ...field };
        if (values && Object.keys(values).length > 0) {
            const accessor = snakeCase(field.name);
            try {
                temp.value =
                  values[field.name] ?? values[accessor] ?? undefined;
            } catch (e) {}
        }
        result.push(temp);
    }

    return result;
}

export function findValues(itemArray: Array<any> | undefined) {
    const result: Array<any> = [];
    if (itemArray) {
        for (const object of itemArray) {
            const newObj: any = {};
            for (const key of Object.keys(object)) {
                const newKey = camelCase(key);
                newObj[newKey] = object[key];
            }
            result.push(newObj);
        }
    }
    return result;
}

export function cleanSubmitData(config: FormConfig, values: FormValues) {
    const result: FormValues = {};
    for (const field of config.fields) {
        if (field.children) {
            const childResult: Array<FormValues> = [];
            if (typeof values[field.name] !== 'undefined') {
                for (const childValue of values[field.name]) {
                    const tempItem: FormValues = {};
                    for (const childField of field.children) {
                        if (
                            childField.type === 'choice' &&
                            childField.attr['data-upload']
                        ) {
                            if (childField?.multiple) {
                                tempItem[childField.name] = childValue[
                                    childField.name
                                ]?.map((i: any) =>
                                    typeof i === 'string' ? i : i.id,
                                );
                            } else {
                                tempItem[childField.name] =
                                    childValue[childField.name]?.id;
                            }
                        } else {
                            tempItem[childField.name] =
                                childValue[childField.name];
                        }
                    }
                    childResult.push(tempItem);
                }
                result[field.name] = childResult ?? [];
            }
        } else {
            if (field.type === 'choice' && field.attr['data-upload']) {
                if (field?.multiple) {
                    result[field.name] = values[field.name]?.map((i: any) =>
                        typeof i === 'string' ? i : i.id,
                    );
                } else {
                    result[field.name] =
                        values[field.name]?.id ?? values[field.name]?.at(0)?.id;
                }
            } else {
                if (values[field.name]) {
                    result[field.name] = values[field.name];
                }
            }
        }
    }
    return result;
}

export function getIds(items: Array<any> = []) {
    const result: Array<string> = [];
    for (const field of items) {
        if (typeof field === 'object') {
            result.push(field.id);
        } else {
            result.push(field);
        }
    }
    return result;
}

export function buildKeyWords(keywords: Array<string>) {
    const result = [];
    for (const keyword of keywords) {
        result.push({ value: keyword });
    }
    return result;
}
